import { User } from '~/hooks/useUserLookup';
import { SessionHydrationUserFields_User_Fragment } from '~/graphql/types';

const isActiveUser = (
  user: User,
): user is SessionHydrationUserFields_User_Fragment =>
  user.__typename === 'User';

export default isActiveUser;
